module.exports = __webpack_public_path__ + "img/icon-filter field.379fd4d8.svg";